import { Client as IClient, Project } from '@types';

export class ClientModel implements IClient {
    id: number;
    obchodne_meno: string;
    projects: Project[];

    constructor({ id, obchodne_meno, projects }: IClient) {
        this.id = id;
        this.obchodne_meno = obchodne_meno;
        this.projects = projects;
    }
}
